module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAABHklEQVQ4T+3TvytFYRzH8ffnT7gGLHfgL2BTZoPuIFmUwSTqJmXQNVEWg4xCoRRGyYAMhjsYKWXwF4jFZvzoW8+pc0/nnNid7Tw/Xn2e7/d5BGB7AjgFBuO/4vsA5iXdFueVkC7wAhzWIAvAiKTxtKdfUsBkyBNwAMTgcgm0AzSBRUmjCfkEziWtFJEBYAY4zkFt4Aj4KiCB3QO7ZUhEns4Q2w/AXUI2gD3gWtKz7bkqZBLYziXZAs4SEuOv0QBJw7bHgMdikm+gU1KTTaARxwHWgQtJjVJE0n5Vd2wv/SO91cnVZBW4AU6AuFetnu78srDR1jWgL54d0P0zkl37fE7ZHkrxroDLmgcYt3gKmM2tiSRvgbyns9Xsr51q/wAw1rYHytPOhgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/gas-icon.png
// module id = PVw6
// module chunks = 1